@if (images().length) {
  <section class="gallery" id="gallery">
    <div class="container">
      <div class="section-header fade-in">
        <span class="section-subtitle">Galéria</span>
        <h2 class="section-title">Pillanatok a Kanyar Büféből</h2>
        <p class="section-description">
          Pákozdi teraszunk, házias fogásaink és a Velencei-tavi környezet pillanatai.
        </p>
      </div>

      <div class="gallery__grid">
        @for (image of images(); track image.src) {
          <div class="gallery__item fade-in" (click)="openLightbox(image.src)">
            <img [ngSrc]="image.src" [alt]="image.alt" loading="lazy" width="600" height="600"/>
            <div class="gallery__item-overlay">
              <span>+</span>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}

@if (lightboxImage()) {
  <div class="lightbox" (click)="closeLightbox()">
    <button class="lightbox__close" aria-label="Bezárás">✕</button>
    <img
      [ngSrc]="lightboxImage()!"
      alt="Kanyar Büfé Pákozd – galéria kép nagyítva"
      width="1600"
      height="1067"
    />
  </div>
}
